import React from 'react';
import { Button } from 'react-bootstrap';
import IconEmail from '../../../images/icon-email.png';
import IconPhone from '../../../images/icon-phone.png';
import IconSsn from '../../../images/icon-ssn.png';
import IconLocation from '../../../images/icon-location.png';
import IconEdit from '../../../images/icon-edit.png';
import { formatPhoneNumber } from '../Auth/utils/phoneFormatter.js';

interface UserProfile {
  fullName: string;
  email: string;
  phone: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

interface ProfileContactInfoProps {
  userProfile: UserProfile;
  onEditProfile: () => void;
}

const ProfileContactInfo: React.FC<ProfileContactInfoProps> = ({
  userProfile,
  onEditProfile
}) => {
  return (
    <>
      {/* Name with Edit */}
      <div className="profile-name-wrapper d-flex align-items-center justify-content-center mb-4">
        <h3
          className="profile-name me-2"
          style={{ color: "#3957A0", fontSize: "20px" }}
        >
          {userProfile.fullName}
        </h3>
        <Button
          variant="link"
          className="edit-profile-btn"
          onClick={onEditProfile}
        >
          <img src={IconEdit} alt="Edit Icon" />
        </Button>
      </div>

      {/* Contact Information */}
      <div className="contact-info-section">
        <div className="contact-info-item">
          <div className="contact-icon email-icon">
            <img src={IconEmail} alt="Email Icon" />
          </div>
          <div className="contact-content">
            <label>Email</label>
            <span>{userProfile.email}</span>
          </div>
        </div>

        <div className="contact-info-item">
          <div className="contact-icon phone-icon">
            <img src={IconPhone} alt="Phone Icon" />
          </div>
          <div className="contact-content">
            <label>Phone</label>
            <span>{userProfile.phone ? formatPhoneNumber(userProfile.phone) : 'N/A'}</span>
          </div>
        </div>

        {/* <div className="contact-info-item">
          <div className="contact-icon ssn-icon">
            <img src={IconSsn} alt="SSN Icon" />
          </div>
          <div className="contact-content">
            <label>SSN</label>
            <span>***-**-7789</span>
          </div>
        </div> */}

        <div className="contact-info-item">
          <div className="contact-icon address-icon">
            <img src={IconLocation} alt="Address Icon" />
          </div>
          <div className="contact-content">
            <label>Address</label>
            <span>
              {userProfile.address1}
              <br />
              {userProfile.city}, {userProfile.state} {userProfile.zip}
            </span>
            {/* Address2 display - commented for later use
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span>{userProfile.address1}</span>
              {userProfile.address2 && (
                <span>{userProfile.address2}</span>
              )}
              <span>{userProfile.city}, {userProfile.state} {userProfile.zip}</span>
            </div>
            */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileContactInfo;